var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M21.6562 18.125C22.3567 16.6382 22.75 14.9659 22.75 13.1979C22.75 7.01348 17.9371 2 12 2C6.06294 2 1.25 7.01348 1.25 13.1979C1.25 14.9659 1.64334 16.6382 2.34383 18.125H6.53569C5.47393 16.797 4.83337 15.0769 4.83337 13.1979C4.83337 8.9925 8.042 5.58333 12 5.58333C15.9581 5.58333 19.1667 8.9925 19.1667 13.1979C19.1667 15.0769 18.5261 16.797 17.4644 18.125H21.6562Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427322567"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 292115",
    cx: 12,
    cy: 20.0011,
    r: 2,
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M11.0987 18.2393L14.3271 12.062C14.4841 11.7617 14.9407 11.9112 14.8896 12.2462L13.8391 19.1366C13.8111 19.3199 13.6253 19.4342 13.4491 19.3765L11.2712 18.6633C11.095 18.6056 11.0128 18.4036 11.0987 18.2393Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M17.5 8L20 6",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.c0383f6424c290897fb4a99b7747c1fa.svg";
export { ForwardRef as ReactComponent };